import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { NavLink, withRouter } from 'react-router-dom';
import { ButtonGroup, UncontrolledTooltip } from 'reactstrap';

import { ROUTES, insertCustomSurveyIdtoUrl } from 'constants/Routes.js';
import ShareButton from 'utils/ShareButton';
import QRCodeButton from 'utils/QRCodeButton';
import PlacardButton from 'utils/PlacardButton';

const SurveyAttributesList = ({
  history,
  deleteCustomSurvey,
  customSurvey,
  locationCount,
}) => {
  const { survey_token, name, business_id, id, rewards } = customSurvey;
  const resizedContainer = locationCount == 1;
  const rowClassName = resizedContainer && 'resized-container';

  const rewardList = rewards.map(reward => reward.title);

  return (
    <tr className={rowClassName}>
      <td>{name || 'Survey'}</td>
      <td>{rewardList}</td>
      <td className="table-separator-td">
        <tr className="custom-survey-quick-link-promote-tr">
          <td className="custom-survey-td">
            <a
              href={`${process.env.REACT_APP_SURVEY_URL}/${survey_token}`}
              target="blank"
            >
              <div
                id={`survey${survey_token}`}
                className="btn btn-outline-secondary btn-sm"
              >
                Survey
                <UncontrolledTooltip
                  placement="bottom"
                  target={`survey${survey_token}`}
                  style={{ fontSize: '0.750em' }}
                >
                  Click here to take survey.
                </UncontrolledTooltip>
              </div>
            </a>
          </td>
          <td className="custom-survey-td">
            <NavLink
              className="btn btn-outline-secondary btn-sm"
              to={insertCustomSurveyIdtoUrl(
                ROUTES.CUSTOM_SURVEY_QUESTIONS,
                business_id,
                id
              )}
              id={`question${survey_token}`}
            >
              Questions
              <UncontrolledTooltip
                placement="bottom"
                target={`question${survey_token}`}
                style={{ fontSize: '0.750em' }}
              >
                View Questions
              </UncontrolledTooltip>
            </NavLink>
          </td>
          <td className="custom-survey-td">
            <NavLink
              className="btn btn-outline-secondary btn-sm"
              to={insertCustomSurveyIdtoUrl(
                ROUTES.CUSTOM_SURVEY_REPORTS,
                business_id,
                customSurvey.id
              )}
              id={`report${survey_token}`}
            >
              Reports
              <UncontrolledTooltip
                placement="bottom"
                target={`report${survey_token}`}
                style={{ fontSize: '0.750em' }}
              >
                View Reports
              </UncontrolledTooltip>
            </NavLink>
          </td>
        </tr>
      </td>
      <td className="table-separator-td">
        <tr className="custom-survey-quick-link-promote-tr">
          <td className="custom-survey-td">
            <ButtonGroup>
              <ShareButton
                id={id}
                url={`${process.env.REACT_APP_SURVEY_URL}/${survey_token}`}
                reward={rewardList}
                name={name}
              />
            </ButtonGroup>
          </td>
          <div>
            <div className="survey-qrcode" id={`qr${survey_token}`} />
            <div className="custom-survey-promote-div">
              <td className="custom-survey-td">
                <QRCodeButton customSurvey={customSurvey} />
              </td>
              <td className="custom-survey-td">
                <PlacardButton customSurvey={customSurvey} />
              </td>
            </div>
          </div>
        </tr>
      </td>
      <td className="table-separator-td">
        <ButtonGroup>
          <a
            className="circular-icon icon-check"
            onClick={() =>
              history.push(
                insertCustomSurveyIdtoUrl(
                  ROUTES.CUSTOM_SURVEY_EDIT,
                  business_id,
                  id
                )
              )
            }
            id={`edit${survey_token}`}
          >
            <FontAwesomeIcon icon="pencil-alt" />
            <UncontrolledTooltip
              placement="bottom"
              target={`edit${survey_token}`}
              style={{ fontSize: '0.750em' }}
            >
              Edit Survey
            </UncontrolledTooltip>
          </a>
          <span
            className="circular-icon icon-cross"
            onClick={deleteCustomSurvey.bind(this, customSurvey, id)}
            id={`delete${survey_token}`}
          >
            <FontAwesomeIcon icon="trash-alt" />
            <UncontrolledTooltip
              placement="bottom"
              target={`delete${survey_token}`}
              style={{ fontSize: '0.750em' }}
            >
              Delete Survey
            </UncontrolledTooltip>
          </span>
        </ButtonGroup>
      </td>
    </tr>
  );
};

SurveyAttributesList.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  deleteCustomSurvey: PropTypes.func.isRequired,
  customSurvey: PropTypes.shape({
    survey_token: PropTypes.string.isRequired,
    name: PropTypes.string,
    business_id: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    rewards: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      })
    ),
  }),
  locationCount: PropTypes.number,
};

SurveyAttributesList.defaultProps = {
  customSurvey: {
    name: 'Survey',
  },
  locationCount: 0,
  rewards: [],
};

export default withRouter(SurveyAttributesList);



// WEBPACK FOOTER //
// ./src/components/customSurvey/SurveyAttributesList.js